/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// State
import { TStore } from '@store/index';
import { StateCreator } from 'zustand';
import {
	TAdditionalProject,
	MesurabilityProject,
	TMesurabilityProjectQuaryParams,
	TMesurabilityProject,
	TAdditionalProjectQuaryParams,
} from '../types';

/* -------------------------------------------------------------------------- */
/*                                  Interface                                 */
/* -------------------------------------------------------------------------- */
export interface IOffsetSlice {
	/************* Offsets **************/
	offsetsMesurabilityProjects: any[];
	offsetsOpenConfirmationModalDelete: any;
	offsetsAdditionalProjects: any[];
	setOffsetsAdditionalProjects: (
		_offsetsAdditionalProjects: any[]
	) => void;
	offsetCreationActiveStep: number;
	offsetCreationDatas: any;
	setOffsetCreationActiveStep: (
		_offsetCreationActiveStep: number
	) => void;
	setOffsetCreationDatas: (
		_offsetCreationDatas: any
	) => void;
	/************************************/

	/************* Start Mint **************/

	isEnabledOffsetNestStep: boolean;
	setIsEnabledOffsetNestStep: (
		_isEnabledOffsetNestStep: boolean
	) => void;

	/************* Offsets **************/
	offsetsTotal: number;
	offsetsPage: number;
	offsetsPageSize: number;
	offsetsTotalPages: number;

	setOffsetsPageSize: (_offsetsPageSize: number) => void;

	setOffsetsPage: (_offsetsPage: number) => void;
	setOffsetsSelectedRecords: (_offsets: any) => void;
	setOffsetsSortStatus: (_offsets: any) => void;
	setOffsetsSelectedRow: (_offsets: any) => void;
	offsetsSelectedRow: any;
	offsetsSortStatus: any;
	offsetsQueryParams: any;
	offsetsSortParams: any;
	offsetsSelectedRecords: any;
	offsetsOpenConfirmationModalVerify: any;
	setOffsetsQueryParams: (
		_offsetsQueryParams: any
	) => void;

	setOffsetsSortParams: (_offsetsSortParams: any) => void;

	/************* Mesurability Projects **************/
	offsetOpenDrawer: boolean;
	offsetStep2Error: boolean;
	offsetStep3Error: boolean;
	setOffsetOpenDrawer: (
		_offsetOpenDrawer: boolean
	) => void;
	offsetMesurabilityProjects: TMesurabilityProject[];
	offsetMesurabilityProjectsSelected: TMesurabilityProject[];
	offsetMesurabilityProjectsTotal: number;
	offsetMesurabilityProjectsPage: number;
	offsetMesurabilityProjectsPageSize: string | number;
	offsetMesurabilityProjectsTotalPages: number;
	offsetMesurabilityProjectsQueryParams: TMesurabilityProjectQuaryParams;
	offsetProducedAddis: number;

	setOffsetStep2Error: (
		_offsetStep2Error: boolean
	) => void;

	setOffsetStep3Error: (
		_offsetStep3Error: boolean
	) => void;

	setOffsetProducedAddis: (
		offsetProducedAddis: number
	) => void;

	setOffsetMesurabilityProjectsSelected: (
		offsetMesurabilityProjectsSelected: TMesurabilityProject[]
	) => void;

	setOffsetMesurabilityProjectsQueryParams: (
		offsetMesurabilityProjectsQueryParams: TMesurabilityProjectQuaryParams
	) => void;

	setOffsetMesurabilityProjects: (
		_offsetsMesurabilityProjects: TMesurabilityProject[]
	) => void;
	setOffsetMesurabilityProjectsTotal: (
		_offsetCreationActiveStep: number
	) => void;
	setOffsetMesurabilityProjectsPage: (
		_offsetCreationActiveStep: number
	) => void;
	setOffsetMesurabilityProjectsPageSize: (
		_offsetCreationActiveStep: string | number
	) => void;
	setOffsetMesurabilityProjectsTotalPages: (
		_offsetCreationActiveStep: number
	) => void;

	/************************************/

	/************* Additional Projects **************/
	offsetAdditionalProjects: TAdditionalProject[];
	offsetAdditionalProjectsSelected: TAdditionalProject[];
	offsetAdditionalProjectsTotal: number;
	offsetAdditionalProjectsPage: number;
	offsetAdditionalProjectsPageSize: number | string;
	offsetAdditionalProjectsTotalPages: number;
	offsetAdditionalProjectsQueryParams: TAdditionalProjectQuaryParams;

	setOffsetAdditionalProjectsSelected: (
		offsetAdditionalProjectsSelected: TAdditionalProject[]
	) => void;

	setOffsetAdditionalProjectsQueryParams: (
		offsetAdditionalProjectsQueryParams: TAdditionalProjectQuaryParams
	) => void;

	setOffsetAdditionalProjects: (
		_offsetsAdditionalProjects: TAdditionalProject[]
	) => void;
	setOffsetAdditionalProjectsTotal: (
		_offsetCreationActiveStep: number
	) => void;
	setOffsetAdditionalProjectsPage: (
		_offsetCreationActiveStep: number
	) => void;
	setOffsetAdditionalProjectsPageSize: (
		_offsetCreationActiveStep: string | number
	) => void;
	setOffsetAdditionalProjectsTotalPages: (
		_offsetCreationActiveStep: number
	) => void;

	/************************************/

	offsetProjectMixinAco2: any;
	offsetProjectMixinAddi: any;
	setOffsetProjectMixinAco2: (
		offsetProjectMixinAco2: any
	) => void;
	setOffsetProjectMixinAddi: (
		offsetProjectMixinAddi: any
	) => void;
}

/* -------------------------------------------------------------------------- */
/*                                    Slice                                   */
/* -------------------------------------------------------------------------- */

const initialState = {
	offsets: [],
	offsetsTotal: 0,
	offsetsPage: 1,
	offsetsPageSize: 10,
	offsetsTotalPages: 0,

	/************* Stepper **************/
	offsetCreationActiveStep: 0,
	offsetCreationDatas: {},
	offsetOpenDrawer: false,
	offsetStep2Error: false,
	offsetStep3Error: false,
	isEnabledOffsetNestStep: false,

	/************************************/
	/************* Mesurability Projects **************/
	offsetMesurabilityProjects: [],
	offsetMesurabilityProjectsTotal: 0,
	offsetMesurabilityProjectsPage: 1,
	offsetMesurabilityProjectsPageSize: 30,
	offsetMesurabilityProjectsTotalPages: 0,

	/************************************/
	offsetsSelectedRecords: [],
	offsetsMesurabilityProjects: [],
	offsetsAdditionalProjects: [],
	offsetsQueryParams: {},
	offsetsSelectedRow: {},
	offsetsSortParams: '-createdAt _id',
	offsetsSortStatus: {},
	offsetsOpenConfirmationModalDelete: {
		open: false,
		params: '',
	},
	offsetsOpenConfirmationModalVerify: {
		open: false,
		params: '',
	},
};

export const createOffsetSlice: StateCreator<
	TStore,
	[],
	[],
	IOffsetSlice
> = (set) => ({
	...initialState,
	setOffsetStep2Error: (_offsetStep2Error: boolean) =>
		set({
			offsetStep2Error: _offsetStep2Error,
		}),
	setIsEnabledOffsetNestStep: (
		_isEnabledOffsetNestStep: boolean
	) =>
		set({
			isEnabledOffsetNestStep: _isEnabledOffsetNestStep,
		}),
	setOffsetStep3Error: (_offsetStep3Error: boolean) =>
		set({
			offsetStep3Error: _offsetStep3Error,
		}),
	setOffsetOpenDrawer: (_offsetOpenDrawer: boolean) =>
		set({
			offsetOpenDrawer: _offsetOpenDrawer,
		}),
	/************* Mesurability Projects **************/
	offsetProjectMixinAco2: [],
	offsetProjectMixinAddi: [],

	offsetMesurabilityProjects: [],
	offsetMesurabilityProjectsSelected: [],
	offsetMesurabilityProjectsTotal: 0,
	offsetMesurabilityProjectsPage: 1,
	offsetMesurabilityProjectsPageSize: 30,
	offsetMesurabilityProjectsTotalPages: 0,
	offsetProducedAddis: 0,
	offsetMesurabilityProjectsQueryParams: {},

	setOffsetProjectMixinAco2: (
		_offsetProjectMixinAco2: any
	) =>
		set({
			offsetProjectMixinAco2: _offsetProjectMixinAco2,
		}),

	setOffsetProjectMixinAddi: (
		_offsetProjectMixinAddi: any
	) =>
		set({
			offsetProjectMixinAddi: _offsetProjectMixinAddi,
		}),

	setOffsetProducedAddis: (
		_offsetProducedAddis: number
	) =>
		set({
			offsetProducedAddis: _offsetProducedAddis,
		}),

	setOffsetMesurabilityProjectsSelected: (
		_offsetMesurabilityProjects: TMesurabilityProject[]
	) =>
		set({
			offsetMesurabilityProjectsSelected:
				_offsetMesurabilityProjects,
		}),

	setOffsetMesurabilityProjects: (
		_offsetMesurabilityProjects: TMesurabilityProject[]
	) =>
		set({
			offsetMesurabilityProjects:
				_offsetMesurabilityProjects,
		}),

	setOffsetMesurabilityProjectsQueryParams: (
		_offsetMesurabilityProjectsQueryParams: TMesurabilityProjectQuaryParams
	) =>
		set({
			offsetMesurabilityProjectsQueryParams:
				_offsetMesurabilityProjectsQueryParams,
		}),

	setOffsetsMesurabilityProjects: (
		_offsetMesurabilityProjects: TMesurabilityProject[]
	) =>
		set({
			offsetMesurabilityProjects:
				_offsetMesurabilityProjects,
		}),

	setOffsetMesurabilityProjectsTotal: (
		_offsetMesurabilityProjectsTotal: number
	) =>
		set({
			offsetMesurabilityProjectsTotal:
				_offsetMesurabilityProjectsTotal,
		}),

	setOffsetMesurabilityProjectsPage: (
		_offsetMesurabilityProjectsPage: number
	) =>
		set({
			offsetMesurabilityProjectsPage:
				_offsetMesurabilityProjectsPage,
		}),

	setOffsetMesurabilityProjectsPageSize: (
		_offsetMesurabilityProjectsPageSize: string | number
	) =>
		set({
			offsetMesurabilityProjectsPageSize:
				_offsetMesurabilityProjectsPageSize,
		}),

	setOffsetMesurabilityProjectsTotalPages: (
		_offsetMesurabilityProjectsTotalPages: number
	) =>
		set({
			offsetMesurabilityProjectsTotalPages:
				_offsetMesurabilityProjectsTotalPages,
		}),

	/************************************/

	/************* Additional Projects **************/
	offsetAdditionalProjects: [],
	offsetAdditionalProjectsSelected: [],
	offsetAdditionalProjectsTotal: 0,
	offsetAdditionalProjectsPage: 1,
	offsetAdditionalProjectsPageSize: 30,
	offsetAdditionalProjectsTotalPages: 0,
	offsetAdditionalProjectsQueryParams: {},

	setOffsetAdditionalProjectsSelected: (
		_offsetAdditionalProjects: TAdditionalProject[]
	) =>
		set({
			offsetAdditionalProjectsSelected:
				_offsetAdditionalProjects,
		}),

	setOffsetAdditionalProjects: (
		_offsetAdditionalProjects: TAdditionalProject[]
	) =>
		set({
			offsetAdditionalProjects: _offsetAdditionalProjects,
		}),

	setOffsetAdditionalProjectsQueryParams: (
		_offsetAdditionalProjectsQueryParams: TAdditionalProjectQuaryParams
	) =>
		set({
			offsetAdditionalProjectsQueryParams:
				_offsetAdditionalProjectsQueryParams,
		}),

	setOffsetsAdditionalProjects: (
		_offsetAdditionalProjects: TAdditionalProject[]
	) =>
		set({
			offsetAdditionalProjects: _offsetAdditionalProjects,
		}),

	setOffsetAdditionalProjectsTotal: (
		_offsetAdditionalProjectsTotal: number
	) =>
		set({
			offsetAdditionalProjectsTotal:
				_offsetAdditionalProjectsTotal,
		}),

	setOffsetAdditionalProjectsPage: (
		_offsetAdditionalProjectsPage: number
	) =>
		set({
			offsetAdditionalProjectsPage:
				_offsetAdditionalProjectsPage,
		}),

	setOffsetAdditionalProjectsPageSize: (
		_offsetAdditionalProjectsPageSize: string | number
	) =>
		set({
			offsetAdditionalProjectsPageSize:
				_offsetAdditionalProjectsPageSize,
		}),

	setOffsetAdditionalProjectsTotalPages: (
		_offsetAdditionalProjectsTotalPages: number
	) =>
		set({
			offsetAdditionalProjectsTotalPages:
				_offsetAdditionalProjectsTotalPages,
		}),

	/************* Stepper **************/

	setOffsetCreationActiveStep: (
		_offsetCreationActiveStep: number
	) =>
		set({
			offsetCreationActiveStep: _offsetCreationActiveStep,
		}),
	setOffsetCreationDatas: (_offsetCreationDatas: any) =>
		set({
			offsetCreationDatas: _offsetCreationDatas,
		}),
	/************************************/
	setOffsetsSelectedRow: (_production: any) =>
		set({ offsetsSelectedRow: _production }),
	setOffsetsSortParams: (_sortStatus: any) =>
		set({ offsetsSortParams: _sortStatus }),
	setOffsetsSortStatus: (_sortStatus: any) =>
		set({ offsetsSortStatus: _sortStatus }),
	setOffsetsQueryParams: (_queryParams: number) =>
		set({ offsetsQueryParams: _queryParams }),
	setOffsetsTotal: (_total: number) =>
		set({ offsetsTotal: _total }),
	setOffsetsOpenConfirmationModalDelete:
		(_offsetsOpenConfirmationModalDelete: {
			open: boolean;
			params: any;
		}) =>
			set({
				offsetsOpenConfirmationModalDelete:
					_offsetsOpenConfirmationModalDelete,
			}),
	setOffsetsOpenConfirmationModalVerify:
		(_offsetsOpenConfirmationModalVerify: {
			open: boolean;
			params: any;
		}) =>
			set({
				offsetsOpenConfirmationModalVerify:
					_offsetsOpenConfirmationModalVerify,
			}),
	setOffsetsPage: (_page: number) =>
		set({ offsetsPage: _page }),
	setOffsetsPageSize: (_pageSize: number) =>
		set({ offsetsPageSize: _pageSize }),
	setOffsetsTotalPages: (_totalPages: number) =>
		set({ offsetsTotalPages: _totalPages }),
	setOffsetsSelectedRecords: (
		_offsetsSelectedRecords: any
	) =>
		set({
			offsetsSelectedRecords: _offsetsSelectedRecords,
		}),
});
